const EmptyBlock = () => <></>;

export default EmptyBlock;
